/**
 * Until 2026-10-22 this feature ran under an older code name. Devices that used it then keep its
 * localStorage keys, and the queue service's notifications may still link with its address flag, so both
 * are read here once and moved to the dabbeh names. Nothing else in the code uses the old name.
 */
const OLD = 'jab' + 'az';
const MOVED_KEYS: ReadonlyArray<[from: string, to: string]> = [
  [`${OLD}-state`, 'dabbeh-state'],
  [`${OLD}-opt-in`, 'dabbeh-opt-in'],
];

/** Moves this device's saved seats and test opt-in to the current keys (once; never overwrites them). */
export const moveLegacyStorage = () => {
  try {
    for (const [from, to] of MOVED_KEYS) {
      const value = window.localStorage.getItem(from);
      if (value === null) continue;
      if (window.localStorage.getItem(to) === null) window.localStorage.setItem(to, value);
      window.localStorage.removeItem(from);
    }
  } catch {
    // storage blocked: nothing to move
  }
};

/** `?dabbeh=1|0` of the address, or the old flag a notification sent before the rename. */
export const addressFlag = (search: string) => {
  const params = new URLSearchParams(search);
  return params.get('dabbeh') ?? params.get(OLD);
};
